// extracted by mini-css-extract-plugin
module.exports = {"logReport":"LogReport_logReport__s5p_E"};